export const themes = {
  itekako: {
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: '#99C74D',
      },
    },
  },
  atlascopco: {
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: 'rgb(0, 153, 204)',
      },
    },
  },
  leybold: {
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: 'rgb(226, 0, 26)',
      },
    },
  },
  edwards: {
    palette: {
      primary: {
        main: '#fff',
      },
      secondary: {
        main: 'rgb(196, 38, 46)',
      },
    },
  },
};

export const headerHeight = 72;
export const subHeaderHeight = 96;



// WEBPACK FOOTER //
// ./src/constants/styles.js